import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './concierge.mutations';
import actions from './concierge.actions';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    currentConcierge: {},
    conciergeList: [],
    conciergeChannels: {}
  },
  mutations,
  actions
};
